unit uAdmin;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.Storage, uHTTPHelper, WEBLib.JSON, WEBLib.JsonData, WEBLib.REST, uGlobal,
  WEBLib.ComCtrls, Types, Vcl.Grids, WEBLib.Grids, System.DateUtils;


type
  TRace = record
    id: integer;
    name: string;
    sprint: integer;
  end;
type
  TfrmAdmin = class(TForm)
    pcAdmin: TPageControl;
    shRaceResult: TTabSheet;
    shUsers: TTabSheet;
    shQualiResult: TTabSheet;
    memo: TMemo;
    btNextRace: TButton;
    btUsers: TButton;
    lbRefreshToken: TLabel;
    lbAccessToken: TLabel;
    lbUsername: TLabel;
    lbUserID: TLabel;
    lbGrandPrix: TLabel;
    cbGrandPrix: TComboBox;
    gdRaceResult: TStringGrid;
    WebLabel1: TLabel;
    gdRaceResDriver: TStringGrid;
    btSaveRaceResult: TButton;
    rbSprint: TRadioButton;
    rbRace: TRadioButton;
    btGenBetResult: TButton;
    lbQualiGrandPrix: TLabel;
    cbQualiGrandPrix: TComboBox;
    rbQualiRace: TRadioButton;
    rbQualiSprint: TRadioButton;
    lbQualiErgebnis: TLabel;
    gdQualiResult: TStringGrid;
    gdQualiResDriver: TStringGrid;
    btSaveQualiResult: TButton;
    edBetResultYear: TEdit;
    btBetResultYear: TButton;
    procedure WebFormCreate(Sender: TObject);
    [async]
    procedure btUsersClick(Sender: TObject); async;
    [async]
    procedure btNextRaceClick(Sender: TObject); async;
    procedure WebFormDestroy(Sender: TObject);
    procedure rbRaceClick(Sender: TObject);
    procedure cbGrandPrixChange(Sender: TObject);
    procedure gdRaceResDriverDblClick(Sender: TObject);
    procedure btSaveRaceResultClick(Sender: TObject);
    procedure btGenBetResultClick(Sender: TObject);
    procedure cbQualiGrandPrixChange(Sender: TObject);
    procedure rbQualiRaceClick(Sender: TObject);
    procedure btSaveQualiResultClick(Sender: TObject);
    procedure gdQualiResDriverDblClick(Sender: TObject);
    procedure gdRaceResDriverKeyPress(Sender: TObject; var Key: Char);
    procedure gdRaceResDriverKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure gdQualiResultKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure btBetResultYearClick(Sender: TObject);
  private
    { Private-Deklarationen }
    procedure ClearGridRaceResult;
    procedure ClearGridQualiResult;
    procedure ClearGridDrivers;
  public
    { Public-Deklarationen }
    races: array of TRace;
    [async]
    procedure GetAllRaces; async;
    [async]
    procedure GetRaceResult; async;
    [async]
    procedure GetQualiResult; async;
    [async]
    procedure GetDrivers; async;
    [async]
    procedure SaveRaceresult; async;
    [async]
    procedure SaveQualiresult; async;
    [async]
    procedure GenBetResult; async;
    [async]
    procedure GenBetResultYear; async;
  protected procedure LoadDFMValues; override; end;

var
  frmAdmin: TfrmAdmin;

implementation

{$R *.dfm}

procedure TfrmAdmin.btBetResultYearClick(Sender: TObject);
begin
  GenBetResultYear;
end;

procedure TfrmAdmin.btGenBetResultClick(Sender: TObject);
begin
  GenBetResult;
end;

procedure TfrmAdmin.btNextRaceClick(Sender: TObject);
var
  jo: TJSONObject;
  status: integer;
begin
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/nextrace/', httpGET, '', jo));
  memo.lines.add('Code: ' + status.ToString + ' - ' +  jo.ToJSON);
end;

procedure TfrmAdmin.btSaveQualiResultClick(Sender: TObject);
begin
  SaveQualiresult;
end;

procedure TfrmAdmin.btSaveRaceResultClick(Sender: TObject);
begin
  SaveRaceresult;
end;

procedure TfrmAdmin.btUsersClick(Sender: TObject);
var
  jo: TJSONObject;
  status: integer;
begin
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/user/', httpGET, '', jo));
  memo.lines.add(jo.ToJSON);

end;

procedure TfrmAdmin.cbGrandPrixChange(Sender: TObject);
begin
  //Setup Radiobuttons
  rbSprint.Visible := (races[cbGrandPrix.ItemIndex].sprint = 1);

  //Hauptrennen vorauswählen
  rbRaceClick(rbRace);
end;

procedure TfrmAdmin.ClearGridDrivers;
var
  i: integer;
begin
  for i := 0 to gdRaceResDriver.RowCount - 1 do
  begin
    gdRaceResDriver.Cells[0, i] := '';
    gdRaceResDriver.Cells[1, i] := '';
  end;
end;

procedure TfrmAdmin.ClearGridQualiResult;
var
  row, col: integer;
  i: Integer;
begin
  gdQualiResult.Cells[0, 0] := 'Pos.';
  gdQualiResult.Cells[1, 0] := 'DriverID';
  gdQualiResult.Cells[2, 0] := 'Driver';

  for i := 1 to gdRaceResult.RowCount - 1 do
  begin
    gdQualiResult.Cells[0, i] := IntToStr(i);
    gdQualiResult.Cells[1, i] := ''; //DriverID
    gdQualiResult.Cells[2, i] := ''; //Driver-Name
  end;
end;

procedure TfrmAdmin.ClearGridRaceResult;
var
  row, col: integer;
  i: Integer;
begin
  gdRaceResult.Cells[0, 0] := 'Pos.';
  gdRaceResult.Cells[1, 0] := 'DriverID';
  gdRaceResult.Cells[2, 0] := 'Driver';

  for i := 1 to gdRaceResult.RowCount - 1 do
  begin
    gdRaceResult.Cells[0, i] := IntToStr(i);
    gdRaceResult.Cells[1, i] := ''; //DriverID
    gdRaceResult.Cells[2, i] := ''; //Driver-Name
  end;
end;

procedure TfrmAdmin.cbQualiGrandPrixChange(Sender: TObject);
begin
  //Setup Radiobuttons
  rbQualiSprint.Visible := (races[cbQualiGrandPrix.ItemIndex].sprint = 1);

  //Hauptrennen vorauswählen
  rbQualiRaceClick(rbQualiRace);
end;

procedure TfrmAdmin.gdQualiResDriverDblClick(Sender: TObject);
begin
  if (gdQualiResDriver.Row >= 0) and (gdQualiResult.Row >= 0) then
  begin
    //Fahrer in Ergebnistabelle eintragen
    gdQualiResult.Cells[1, gdQualiResult.Row] := gdQualiResDriver.Cells[0, gdQualiResDriver.Row];
    gdQualiResult.Cells[2, gdQualiResult.Row] := gdQualiResDriver.Cells[1, gdQualiResDriver.Row];

    //Zur nächsten Reihen springen falls möglich
    if (gdQualiResult.Row + 1 < gdQualiResult.RowCount) then
      gdQualiResult.Row := gdQualiResult.Row + 1;

  end;
end;

procedure TfrmAdmin.gdQualiResultKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
var
  grid: TStringGrid;
begin
  grid := (Sender as TStringGrid);
  if (Key = VK_DELETE) and (grid.Row >= 0) then
  begin
    grid.Cells[1, grid.Row] := '';
    grid.Cells[2, grid.Row] := '';
  end;

end;

procedure TfrmAdmin.gdRaceResDriverDblClick(Sender: TObject);
begin
  if (gdRaceResDriver.Row >= 0) and (gdRaceResult.Row >= 0) then
  begin
    //Fahrer in Ergebnistabelle eintragen
    gdRaceResult.Cells[1, gdRaceResult.Row] := gdRaceResDriver.Cells[0, gdRaceResDriver.Row];
    gdRaceResult.Cells[2, gdRaceResult.Row] := gdRaceResDriver.Cells[1, gdRaceResDriver.Row];

    //Zur nächsten Reihen springen falls möglich
    if (gdRaceResult.Row + 1 < gdRaceResult.RowCount) then
      gdRaceResult.Row := gdRaceResult.Row + 1;

  end;
end;

procedure TfrmAdmin.gdRaceResDriverKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  if (Key = VK_RETURN) then
  begin
    if (Sender = gdRaceResDriver) then
      gdRaceResDriverDblClick(gdRaceResDriver)
    else if (Sender = gdQualiResDriver) then
      gdQualiResDriverDblClick(gdQualiResDriver);
  end;
end;

procedure TfrmAdmin.gdRaceResDriverKeyPress(Sender: TObject; var Key: Char);
var
  grid: TStringGrid;
  i, r : integer;
begin
  //Anfangsbuchstabe des Fahrernachnamens anspringen
  grid := (Sender as TStringGrid);

  //steh ich bereits auf einem Eintrag welcher mit dem Buchstaben beginnt,
  //schauen ob nächster Eintrag auch damit beginnt


  for i := 0 to grid.RowCount - 1 do
  begin
    r := grid.Row + i + 1;
    if (r > grid.RowCount - 1) then
      r := r - grid.RowCount;

    if grid.Cells[1, r].StartsWith(UpperCase(key)) then
    begin
      grid.Row := r;
      break;
    end;
  end;



end;

procedure TfrmAdmin.GenBetResult;
var
  joReq, joResp, jo, joEntry :TJSONObject;

  jaResult: TJSONArray;
  status, i, row : integer;
begin
  //Ermittelt das Tipp-Ergebnis (BetResult) für das angegebene Rennen
  joReq := TJSONObject.Create;
  joReq.AddPair('race_id', races[cbGrandPrix.ItemIndex].id);
  if (rbRace.Checked) then
    joReq.AddPair('sprint', 0)
  else
    joReq.AddPair('sprint', 1);



  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/genbetresult/', httpPOST, joReq.ToJSON, joResp));
  jaResult.Free;
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      ShowMessage(joResp.GetJSONValue('message'));

    finally
      joResp.free;
    end;
  end;
end;

procedure TfrmAdmin.GenBetResultYear;
var
  joReq, joResp, jo, joEntry :TJSONObject;

  jaResult: TJSONArray;
  status, i, row : integer;
begin
  //Ermittelt das Tipp-Ergebnis (BetResult) für das angegebene JAHR
  joReq := TJSONObject.Create;
  joReq.AddPair('year', StrToInt(edBetResultYear.Text));



  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/genbetresultyear/', httpPOST, joReq.ToJSON, joResp));
  jaResult.Free;
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      ShowMessage(joResp.GetJSONValue('message'));

    finally
      joResp.free;
    end;
  end;
end;

procedure TfrmAdmin.GetAllRaces;
var
  joReq, joResp, jo: TJSONObject;
  jaResp: TJSONArray;
  status, i : integer;
begin
  //Holt sich alle GrandPrix-Bezeichnungen und trägt diese in die Combobox ein
  SetLength(races, 0);
  joReq := TJSONObject.Create;
  joReq.AddPair('year', YearOf(now));
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/allraces/', httpPOST, joReq.ToJSON, joResp));
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      jaResp := TJSONArray(joResp);
      for i := 0 to jaResp.Count - 1 do
      begin
        //GrandPrix's
        SetLength(races, Length(races) + 1);
        jo := TJSONObject(jaResp[i]);
        races[High(races)].id := StrToInt(jo.GetJSONValue('id'));
        races[High(races)].name := jo.GetJSONValue('race_name');
        if (jo.GetValue('sprint') <> nil) then
          races[High(races)].sprint := 1
        else
          races[High(races)].sprint := 0;
      end;

      //Comboboxen befüllen
      cbGrandPrix.Clear;
      cbQualiGrandPrix.Clear;
      for i := 0 to High(races) do
      begin
        cbGrandPrix.AddItem(races[i].name, nil);
        cbQualiGrandPrix.AddItem(races[i].name, nil);
      end;

      if (Length(races) > 0) then
      begin
        cbGrandPrix.ItemIndex := 0;
        cbGrandPrixChange(cbGrandPrix);

        cbQualiGrandPrix.ItemIndex := 0;
        cbQualiGrandPrixChange(cbGrandPrix);
      end;

    finally
      jaResp.free;
    end;
  end;
end;

procedure TfrmAdmin.GetDrivers;
var
  joReq, joResp, jo: TJSONObject;
  jaResp: TJSONArray;
  status, i, row : integer;
begin
  //Holt sich alle verfügbaren Fahrer und trägt diese in die Tabelle ein
  ClearGridDrivers;

  joReq := TJSONObject.Create;

  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/drivers/', httpGET, joReq.ToJSON, joResp));
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      jaResp := TJSONArray(joResp);
      for i := 0 to jaResp.Count - 1 do
      begin
        //Fahrer
        jo := TJSONObject(jaResp[i]);
        gdRaceResDriver.Cells[0, i] := jo.GetJSONValue('id');
        gdRaceResDriver.Cells[1, i] := jo.GetJSONValue('familyname');

        gdQualiResDriver.Cells[0, i] := jo.GetJSONValue('id');
        gdQualiResDriver.Cells[1, i] := jo.GetJSONValue('familyname');
      end;

    finally
      jo.free;
      jaResp.free;
    end;
  end;

end;

procedure TfrmAdmin.GetQualiResult;
var
  joReq, joResp, jo: TJSONObject;
  jaResp: TJSONArray;
  status, i, row : integer;
begin
  //Holt zum auswählten Rennen und gewählten Hauptrennen / Sprint
  //das Ergebnis und schreibt es in die Tabelle
  ClearGridQualiResult;

  joReq := TJSONObject.Create;
  joReq.AddPair('race_id', races[cbQualiGrandPrix.ItemIndex].id);
  if (rbQualiRace.Checked) then
    joReq.AddPair('sprint', 0)
  else
    joReq.AddPair('sprint', 1);

  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/qualiresult/', httpPOST, joReq.ToJSON, joResp));
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      jaResp := TJSONArray(joResp);
      for i := 0 to jaResp.Count - 1 do
      begin
        //GrandPrix's

        jo := TJSONObject(jaResp[i]);
        row := StrToInt(jo.GetJSONValue('position'));
        gdQualiResult.Cells[1, row] := jo.GetJSONValue('driver_id');
        gdQualiResult.Cells[2, row] := {jo.GetJSONValue('givenname') + ' ' +} jo.GetJSONValue('familyname');
      end;

    finally
      jo.free;
      jaResp.free;
    end;
  end;
end;

procedure TfrmAdmin.GetRaceResult;
var
  joReq, joResp, jo: TJSONObject;
  jaResp: TJSONArray;
  status, i, row : integer;
begin
  //Holt zum auswählten Rennen und gewählten Hauptrennen / Sprint
  //das Ergebnis und schreibt es in die Tabelle
  ClearGridRaceResult;

  joReq := TJSONObject.Create;
  joReq.AddPair('race_id', races[cbGrandPrix.ItemIndex].id);
  if (rbRace.Checked) then
    joReq.AddPair('sprint', 0)
  else
    joReq.AddPair('sprint', 1);

  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/raceresult/', httpPOST, joReq.ToJSON, joResp));
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      jaResp := TJSONArray(joResp);
      for i := 0 to jaResp.Count - 1 do
      begin
        //GrandPrix's

        jo := TJSONObject(jaResp[i]);
        row := StrToInt(jo.GetJSONValue('position'));
        gdRaceResult.Cells[1, row] := jo.GetJSONValue('driver_id');
        gdRaceResult.Cells[2, row] := {jo.GetJSONValue('givenname') + ' ' +} jo.GetJSONValue('familyname');
      end;

    finally
      jo.free;
      jaResp.free;
    end;
  end;
end;

procedure TfrmAdmin.rbQualiRaceClick(Sender: TObject);
var
  rb2: TRadioButton;
begin

  if (Sender = rbQualiSprint) then
    rb2 := rbQualiRace
  else
    rb2 := rbQualiSprint;

  (Sender as TRadioButton).Checked := True;
  rb2.Checked := False;

  //Rennergebnis holen
  GetQualiResult;

end;

procedure TfrmAdmin.rbRaceClick(Sender: TObject);
var
  rb2: TRadioButton;
begin

  if (Sender = rbSprint) then
    rb2 := rbRace
  else
    rb2 := rbSprint;

  (Sender as TRadioButton).Checked := True;
  rb2.Checked := False;

  //Rennergebnis holen
  GetRaceResult;

end;

procedure TfrmAdmin.SaveQualiresult;
var
  joReq, joResp, jo, joEntry :TJSONObject;

  jaResult: TJSONArray;
  status, i, row : integer;
begin
  //Speichert das angegebene Quali-Ergebnis in der Datenbank
  joReq := TJSONObject.Create;
  joReq.AddPair('race_id', races[cbQualiGrandPrix.ItemIndex].id);
  if (rbQualiRace.Checked) then
    joReq.AddPair('sprint', 0)
  else
    joReq.AddPair('sprint', 1);

  jaResult := TJSONArray.Create;
  for i := 1 to gdQualiResult.RowCount - 1 do
  begin
    if (gdQualiResult.Cells[1, i] <> '') then
    begin
      joEntry := TJSONObject.Create;
      joEntry.AddPair('position', gdQualiResult.Cells[0, i]);
      joEntry.AddPair('id', gdQualiResult.Cells[1, i]);
      joEntry.AddPair('driver_name', gdQualiResult.Cells[2, i]);
      jaResult.add(joEntry);
    end;
  end;
  joReq.AddPair('qualiresult', jaResult);

  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/setqualiresult/', httpPOST, joReq.ToJSON, joResp));
  jaResult.Free;
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      ShowMessage(joResp.GetJSONValue('message'));

    finally
      joResp.free;
    end;
  end;
end;

procedure TfrmAdmin.SaveRaceresult;
var
  joReq, joResp, jo, joEntry :TJSONObject;

  jaResult: TJSONArray;
  status, i, row : integer;
begin
  //Speichert das angegebene Rennergebnis in der Datenbank
  joReq := TJSONObject.Create;
  joReq.AddPair('race_id', races[cbGrandPrix.ItemIndex].id);
  if (rbRace.Checked) then
    joReq.AddPair('sprint', 0)
  else
    joReq.AddPair('sprint', 1);

  jaResult := TJSONArray.Create;
  for i := 1 to gdRaceResult.RowCount - 1 do
  begin
    if (gdRaceResult.Cells[1, i] <> '') then
    begin
      joEntry := TJSONObject.Create;
      joEntry.AddPair('position', gdRaceResult.Cells[0, i]);
      joEntry.AddPair('id', gdRaceResult.Cells[1, i]);
      joEntry.AddPair('driver_name', gdRaceResult.Cells[2, i]);
      jaResult.add(joEntry);
    end;
  end;
  joReq.AddPair('raceresult', jaResult);

  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/setraceresult/', httpPOST, joReq.ToJSON, joResp));
  jaResult.Free;
  joReq.free;

  if (status = HTTP_OK) then
  begin
    try
      ShowMessage(joResp.GetJSONValue('message'));

    finally
      joResp.free;
    end;
  end;
end;

procedure TfrmAdmin.WebFormCreate(Sender: TObject);
var
  ls: TLocalStorage;
begin
  ls := TLocalStorage.create(nil);
  try
    lbUserID.Caption := ls.GetValue('userid');
    lbUsername.Caption := ls.GetValue('username');
    lbAccessToken.Caption := ls.GetValue('accesstoken');
    lbRefreshToken.Caption := ls.GetValue('refreshtoken');
  finally
    ls.free;
  end;

  //Grand-Prixs holen
  GetAllRaces;
  GetDrivers;

end;

procedure TfrmAdmin.WebFormDestroy(Sender: TObject);
begin
  SetLength(races, 0);
end;

procedure TfrmAdmin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pcAdmin := TPageControl.Create(Self);
  shRaceResult := TTabSheet.Create(Self);
  lbGrandPrix := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  cbGrandPrix := TComboBox.Create(Self);
  gdRaceResult := TStringGrid.Create(Self);
  gdRaceResDriver := TStringGrid.Create(Self);
  btSaveRaceResult := TButton.Create(Self);
  rbSprint := TRadioButton.Create(Self);
  rbRace := TRadioButton.Create(Self);
  btGenBetResult := TButton.Create(Self);
  edBetResultYear := TEdit.Create(Self);
  btBetResultYear := TButton.Create(Self);
  shQualiResult := TTabSheet.Create(Self);
  lbQualiGrandPrix := TLabel.Create(Self);
  lbQualiErgebnis := TLabel.Create(Self);
  cbQualiGrandPrix := TComboBox.Create(Self);
  rbQualiRace := TRadioButton.Create(Self);
  rbQualiSprint := TRadioButton.Create(Self);
  gdQualiResult := TStringGrid.Create(Self);
  gdQualiResDriver := TStringGrid.Create(Self);
  btSaveQualiResult := TButton.Create(Self);
  shUsers := TTabSheet.Create(Self);
  lbRefreshToken := TLabel.Create(Self);
  lbAccessToken := TLabel.Create(Self);
  lbUsername := TLabel.Create(Self);
  lbUserID := TLabel.Create(Self);
  memo := TMemo.Create(Self);
  btNextRace := TButton.Create(Self);
  btUsers := TButton.Create(Self);

  pcAdmin.BeforeLoadDFMValues;
  shRaceResult.BeforeLoadDFMValues;
  lbGrandPrix.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  cbGrandPrix.BeforeLoadDFMValues;
  gdRaceResult.BeforeLoadDFMValues;
  gdRaceResDriver.BeforeLoadDFMValues;
  btSaveRaceResult.BeforeLoadDFMValues;
  rbSprint.BeforeLoadDFMValues;
  rbRace.BeforeLoadDFMValues;
  btGenBetResult.BeforeLoadDFMValues;
  edBetResultYear.BeforeLoadDFMValues;
  btBetResultYear.BeforeLoadDFMValues;
  shQualiResult.BeforeLoadDFMValues;
  lbQualiGrandPrix.BeforeLoadDFMValues;
  lbQualiErgebnis.BeforeLoadDFMValues;
  cbQualiGrandPrix.BeforeLoadDFMValues;
  rbQualiRace.BeforeLoadDFMValues;
  rbQualiSprint.BeforeLoadDFMValues;
  gdQualiResult.BeforeLoadDFMValues;
  gdQualiResDriver.BeforeLoadDFMValues;
  btSaveQualiResult.BeforeLoadDFMValues;
  shUsers.BeforeLoadDFMValues;
  lbRefreshToken.BeforeLoadDFMValues;
  lbAccessToken.BeforeLoadDFMValues;
  lbUsername.BeforeLoadDFMValues;
  lbUserID.BeforeLoadDFMValues;
  memo.BeforeLoadDFMValues;
  btNextRace.BeforeLoadDFMValues;
  btUsers.BeforeLoadDFMValues;
  try
    Name := 'frmAdmin';
    Width := 1045;
    Height := 619;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    pcAdmin.SetParentComponent(Self);
    pcAdmin.Name := 'pcAdmin';
    pcAdmin.Left := 0;
    pcAdmin.Top := 0;
    pcAdmin.Width := 1045;
    pcAdmin.Height := 619;
    pcAdmin.Align := alClient;
    pcAdmin.ChildOrder := 7;
    pcAdmin.TabIndex := 0;
    pcAdmin.TabOrder := 0;
    shRaceResult.SetParentComponent(pcAdmin);
    shRaceResult.Name := 'shRaceResult';
    shRaceResult.Left := 0;
    shRaceResult.Top := 20;
    shRaceResult.Width := 1045;
    shRaceResult.Height := 599;
    shRaceResult.Caption := 'Rennergebnisse';
    lbGrandPrix.SetParentComponent(shRaceResult);
    lbGrandPrix.Name := 'lbGrandPrix';
    lbGrandPrix.Left := 8;
    lbGrandPrix.Top := 16;
    lbGrandPrix.Width := 54;
    lbGrandPrix.Height := 15;
    lbGrandPrix.Caption := 'Grand Prix';
    lbGrandPrix.HeightPercent := 100.000000000000000000;
    lbGrandPrix.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(shRaceResult);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 11;
    WebLabel1.Top := 53;
    WebLabel1.Width := 45;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Ergebnis';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    cbGrandPrix.SetParentComponent(shRaceResult);
    cbGrandPrix.Name := 'cbGrandPrix';
    cbGrandPrix.Left := 81;
    cbGrandPrix.Top := 13;
    cbGrandPrix.Width := 304;
    cbGrandPrix.Height := 23;
    cbGrandPrix.HeightPercent := 100.000000000000000000;
    cbGrandPrix.WidthPercent := 100.000000000000000000;
    SetEvent(cbGrandPrix, Self, 'OnChange', 'cbGrandPrixChange');
    cbGrandPrix.ItemIndex := -1;
    gdRaceResult.SetParentComponent(shRaceResult);
    gdRaceResult.Name := 'gdRaceResult';
    gdRaceResult.Left := 8;
    gdRaceResult.Top := 73;
    gdRaceResult.Width := 377;
    gdRaceResult.Height := 480;
    gdRaceResult.Anchors := [akLeft,akTop,akBottom];
    gdRaceResult.ColCount := 3;
    gdRaceResult.RowCount := 25;
    gdRaceResult.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    gdRaceResult.TabOrder := 1;
    SetEvent(gdRaceResult, Self, 'OnKeyDown', 'gdQualiResultKeyDown');
    gdRaceResult.FixedFont.Charset := DEFAULT_CHARSET;
    gdRaceResult.FixedFont.Color := clWindowText;
    gdRaceResult.FixedFont.Height := -12;
    gdRaceResult.FixedFont.Name := 'Segoe UI';
    gdRaceResult.FixedFont.Style := [];
    gdRaceResult.RangeEdit.Max := 100.000000000000000000;
    gdRaceResult.RangeEdit.Step := 1.000000000000000000;
    gdRaceResult.HeightPercent := 100.000000000000000000;
    gdRaceResult.WidthPercent := 100.000000000000000000;
    gdRaceResult.ColWidths[0] := 64;
    gdRaceResult.ColWidths[1] := 64;
    gdRaceResult.ColWidths[2] := 219;
    gdRaceResDriver.SetParentComponent(shRaceResult);
    gdRaceResDriver.Name := 'gdRaceResDriver';
    gdRaceResDriver.Left := 408;
    gdRaceResDriver.Top := 73;
    gdRaceResDriver.Width := 297;
    gdRaceResDriver.Height := 523;
    gdRaceResDriver.Anchors := [akLeft,akTop,akBottom];
    gdRaceResDriver.ColCount := 2;
    gdRaceResDriver.FixedCols := 0;
    gdRaceResDriver.RowCount := 30;
    gdRaceResDriver.FixedRows := 0;
    gdRaceResDriver.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    gdRaceResDriver.TabOrder := 2;
    SetEvent(gdRaceResDriver, Self, 'OnDblClick', 'gdRaceResDriverDblClick');
    SetEvent(gdRaceResDriver, Self, 'OnKeyDown', 'gdRaceResDriverKeyDown');
    SetEvent(gdRaceResDriver, Self, 'OnKeyPress', 'gdRaceResDriverKeyPress');
    gdRaceResDriver.FixedFont.Charset := DEFAULT_CHARSET;
    gdRaceResDriver.FixedFont.Color := clWindowText;
    gdRaceResDriver.FixedFont.Height := -12;
    gdRaceResDriver.FixedFont.Name := 'Segoe UI';
    gdRaceResDriver.FixedFont.Style := [];
    gdRaceResDriver.RangeEdit.Max := 100.000000000000000000;
    gdRaceResDriver.RangeEdit.Step := 1.000000000000000000;
    gdRaceResDriver.HeightPercent := 100.000000000000000000;
    gdRaceResDriver.WidthPercent := 100.000000000000000000;
    gdRaceResDriver.ColWidths[0] := 64;
    gdRaceResDriver.ColWidths[1] := 207;
    btSaveRaceResult.SetParentComponent(shRaceResult);
    btSaveRaceResult.Name := 'btSaveRaceResult';
    btSaveRaceResult.Left := 5;
    btSaveRaceResult.Top := 563;
    btSaveRaceResult.Width := 92;
    btSaveRaceResult.Height := 25;
    btSaveRaceResult.Anchors := [akLeft,akBottom];
    btSaveRaceResult.Caption := 'Speichern';
    btSaveRaceResult.ChildOrder := 5;
    btSaveRaceResult.HeightPercent := 100.000000000000000000;
    btSaveRaceResult.WidthPercent := 100.000000000000000000;
    SetEvent(btSaveRaceResult, Self, 'OnClick', 'btSaveRaceResultClick');
    rbSprint.SetParentComponent(shRaceResult);
    rbSprint.Name := 'rbSprint';
    rbSprint.Left := 192;
    rbSprint.Top := 39;
    rbSprint.Width := 97;
    rbSprint.Height := 22;
    rbSprint.Caption := 'Sprint';
    rbSprint.Checked := False;
    rbSprint.ChildOrder := 6;
    rbSprint.Color := clNone;
    rbSprint.HeightPercent := 100.000000000000000000;
    rbSprint.WidthPercent := 100.000000000000000000;
    SetEvent(rbSprint, Self, 'OnClick', 'rbRaceClick');
    rbRace.SetParentComponent(shRaceResult);
    rbRace.Name := 'rbRace';
    rbRace.Left := 80;
    rbRace.Top := 39;
    rbRace.Width := 97;
    rbRace.Height := 22;
    rbRace.Caption := 'Hauptrennen';
    rbRace.Checked := False;
    rbRace.ChildOrder := 6;
    rbRace.Color := clNone;
    rbRace.HeightPercent := 100.000000000000000000;
    rbRace.WidthPercent := 100.000000000000000000;
    SetEvent(rbRace, Self, 'OnClick', 'rbRaceClick');
    btGenBetResult.SetParentComponent(shRaceResult);
    btGenBetResult.Name := 'btGenBetResult';
    btGenBetResult.Left := 103;
    btGenBetResult.Top := 563;
    btGenBetResult.Width := 138;
    btGenBetResult.Height := 25;
    btGenBetResult.Anchors := [akLeft,akBottom];
    btGenBetResult.Caption := 'Tippergebnis ermitteln';
    btGenBetResult.ChildOrder := 5;
    btGenBetResult.HeightPercent := 100.000000000000000000;
    btGenBetResult.WidthPercent := 100.000000000000000000;
    SetEvent(btGenBetResult, Self, 'OnClick', 'btGenBetResultClick');
    edBetResultYear.SetParentComponent(shRaceResult);
    edBetResultYear.Name := 'edBetResultYear';
    edBetResultYear.Left := 719;
    edBetResultYear.Top := 76;
    edBetResultYear.Width := 121;
    edBetResultYear.Height := 22;
    edBetResultYear.ChildOrder := 9;
    edBetResultYear.HeightPercent := 100.000000000000000000;
    edBetResultYear.Text := '2025';
    edBetResultYear.WidthPercent := 100.000000000000000000;
    btBetResultYear.SetParentComponent(shRaceResult);
    btBetResultYear.Name := 'btBetResultYear';
    btBetResultYear.Left := 719;
    btBetResultYear.Top := 112;
    btBetResultYear.Width := 202;
    btBetResultYear.Height := 25;
    btBetResultYear.Caption := 'BetResult f'#252'r ganzes Jahr';
    btBetResultYear.ChildOrder := 10;
    btBetResultYear.HeightPercent := 100.000000000000000000;
    btBetResultYear.WidthPercent := 100.000000000000000000;
    SetEvent(btBetResultYear, Self, 'OnClick', 'btBetResultYearClick');
    shQualiResult.SetParentComponent(pcAdmin);
    shQualiResult.Name := 'shQualiResult';
    shQualiResult.Left := 0;
    shQualiResult.Top := 20;
    shQualiResult.Width := 1045;
    shQualiResult.Height := 599;
    shQualiResult.Caption := 'Qualiergebnisse';
    shQualiResult.ChildOrder := 2;
    lbQualiGrandPrix.SetParentComponent(shQualiResult);
    lbQualiGrandPrix.Name := 'lbQualiGrandPrix';
    lbQualiGrandPrix.Left := 16;
    lbQualiGrandPrix.Top := 24;
    lbQualiGrandPrix.Width := 54;
    lbQualiGrandPrix.Height := 15;
    lbQualiGrandPrix.Caption := 'Grand Prix';
    lbQualiGrandPrix.HeightPercent := 100.000000000000000000;
    lbQualiGrandPrix.WidthPercent := 100.000000000000000000;
    lbQualiErgebnis.SetParentComponent(shQualiResult);
    lbQualiErgebnis.Name := 'lbQualiErgebnis';
    lbQualiErgebnis.Left := 19;
    lbQualiErgebnis.Top := 61;
    lbQualiErgebnis.Width := 45;
    lbQualiErgebnis.Height := 15;
    lbQualiErgebnis.Caption := 'Ergebnis';
    lbQualiErgebnis.HeightPercent := 100.000000000000000000;
    lbQualiErgebnis.WidthPercent := 100.000000000000000000;
    cbQualiGrandPrix.SetParentComponent(shQualiResult);
    cbQualiGrandPrix.Name := 'cbQualiGrandPrix';
    cbQualiGrandPrix.Left := 89;
    cbQualiGrandPrix.Top := 21;
    cbQualiGrandPrix.Width := 304;
    cbQualiGrandPrix.Height := 23;
    cbQualiGrandPrix.HeightPercent := 100.000000000000000000;
    cbQualiGrandPrix.WidthPercent := 100.000000000000000000;
    SetEvent(cbQualiGrandPrix, Self, 'OnChange', 'cbQualiGrandPrixChange');
    cbQualiGrandPrix.ItemIndex := -1;
    rbQualiRace.SetParentComponent(shQualiResult);
    rbQualiRace.Name := 'rbQualiRace';
    rbQualiRace.Left := 88;
    rbQualiRace.Top := 47;
    rbQualiRace.Width := 97;
    rbQualiRace.Height := 22;
    rbQualiRace.Caption := 'Hauptrennen';
    rbQualiRace.Checked := False;
    rbQualiRace.ChildOrder := 6;
    rbQualiRace.Color := clNone;
    rbQualiRace.HeightPercent := 100.000000000000000000;
    rbQualiRace.WidthPercent := 100.000000000000000000;
    SetEvent(rbQualiRace, Self, 'OnClick', 'rbQualiRaceClick');
    rbQualiSprint.SetParentComponent(shQualiResult);
    rbQualiSprint.Name := 'rbQualiSprint';
    rbQualiSprint.Left := 200;
    rbQualiSprint.Top := 47;
    rbQualiSprint.Width := 97;
    rbQualiSprint.Height := 22;
    rbQualiSprint.Caption := 'Sprint';
    rbQualiSprint.Checked := False;
    rbQualiSprint.ChildOrder := 6;
    rbQualiSprint.Color := clNone;
    rbQualiSprint.HeightPercent := 100.000000000000000000;
    rbQualiSprint.WidthPercent := 100.000000000000000000;
    SetEvent(rbQualiSprint, Self, 'OnClick', 'rbQualiRaceClick');
    gdQualiResult.SetParentComponent(shQualiResult);
    gdQualiResult.Name := 'gdQualiResult';
    gdQualiResult.Left := 16;
    gdQualiResult.Top := 81;
    gdQualiResult.Width := 377;
    gdQualiResult.Height := 480;
    gdQualiResult.Anchors := [akLeft,akTop,akBottom];
    gdQualiResult.ColCount := 3;
    gdQualiResult.RowCount := 25;
    gdQualiResult.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    gdQualiResult.TabOrder := 3;
    SetEvent(gdQualiResult, Self, 'OnKeyDown', 'gdQualiResultKeyDown');
    gdQualiResult.FixedFont.Charset := DEFAULT_CHARSET;
    gdQualiResult.FixedFont.Color := clWindowText;
    gdQualiResult.FixedFont.Height := -12;
    gdQualiResult.FixedFont.Name := 'Segoe UI';
    gdQualiResult.FixedFont.Style := [];
    gdQualiResult.RangeEdit.Max := 100.000000000000000000;
    gdQualiResult.RangeEdit.Step := 1.000000000000000000;
    gdQualiResult.HeightPercent := 100.000000000000000000;
    gdQualiResult.WidthPercent := 100.000000000000000000;
    gdQualiResult.ColWidths[0] := 64;
    gdQualiResult.ColWidths[1] := 64;
    gdQualiResult.ColWidths[2] := 219;
    gdQualiResDriver.SetParentComponent(shQualiResult);
    gdQualiResDriver.Name := 'gdQualiResDriver';
    gdQualiResDriver.Left := 416;
    gdQualiResDriver.Top := 76;
    gdQualiResDriver.Width := 297;
    gdQualiResDriver.Height := 523;
    gdQualiResDriver.Anchors := [akLeft,akTop,akBottom];
    gdQualiResDriver.ColCount := 2;
    gdQualiResDriver.FixedCols := 0;
    gdQualiResDriver.RowCount := 30;
    gdQualiResDriver.FixedRows := 0;
    gdQualiResDriver.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    gdQualiResDriver.TabOrder := 4;
    SetEvent(gdQualiResDriver, Self, 'OnDblClick', 'gdQualiResDriverDblClick');
    SetEvent(gdQualiResDriver, Self, 'OnKeyDown', 'gdRaceResDriverKeyDown');
    SetEvent(gdQualiResDriver, Self, 'OnKeyPress', 'gdRaceResDriverKeyPress');
    gdQualiResDriver.FixedFont.Charset := DEFAULT_CHARSET;
    gdQualiResDriver.FixedFont.Color := clWindowText;
    gdQualiResDriver.FixedFont.Height := -12;
    gdQualiResDriver.FixedFont.Name := 'Segoe UI';
    gdQualiResDriver.FixedFont.Style := [];
    gdQualiResDriver.RangeEdit.Max := 100.000000000000000000;
    gdQualiResDriver.RangeEdit.Step := 1.000000000000000000;
    gdQualiResDriver.HeightPercent := 100.000000000000000000;
    gdQualiResDriver.WidthPercent := 100.000000000000000000;
    gdQualiResDriver.ColWidths[0] := 64;
    gdQualiResDriver.ColWidths[1] := 207;
    btSaveQualiResult.SetParentComponent(shQualiResult);
    btSaveQualiResult.Name := 'btSaveQualiResult';
    btSaveQualiResult.Left := 13;
    btSaveQualiResult.Top := 571;
    btSaveQualiResult.Width := 92;
    btSaveQualiResult.Height := 25;
    btSaveQualiResult.Anchors := [akLeft,akBottom];
    btSaveQualiResult.Caption := 'Speichern';
    btSaveQualiResult.ChildOrder := 5;
    btSaveQualiResult.HeightPercent := 100.000000000000000000;
    btSaveQualiResult.WidthPercent := 100.000000000000000000;
    SetEvent(btSaveQualiResult, Self, 'OnClick', 'btSaveQualiResultClick');
    shUsers.SetParentComponent(pcAdmin);
    shUsers.Name := 'shUsers';
    shUsers.Left := 0;
    shUsers.Top := 20;
    shUsers.Width := 1045;
    shUsers.Height := 599;
    shUsers.Caption := 'Benutzer';
    shUsers.ChildOrder := 1;
    lbRefreshToken.SetParentComponent(shUsers);
    lbRefreshToken.Name := 'lbRefreshToken';
    lbRefreshToken.Left := 8;
    lbRefreshToken.Top := 66;
    lbRefreshToken.Width := 71;
    lbRefreshToken.Height := 15;
    lbRefreshToken.Caption := 'RefreshToken';
    lbRefreshToken.HeightPercent := 100.000000000000000000;
    lbRefreshToken.WidthPercent := 100.000000000000000000;
    lbAccessToken.SetParentComponent(shUsers);
    lbAccessToken.Name := 'lbAccessToken';
    lbAccessToken.Left := 8;
    lbAccessToken.Top := 45;
    lbAccessToken.Width := 68;
    lbAccessToken.Height := 15;
    lbAccessToken.Caption := 'AccessToken';
    lbAccessToken.HeightPercent := 100.000000000000000000;
    lbAccessToken.WidthPercent := 100.000000000000000000;
    lbUsername.SetParentComponent(shUsers);
    lbUsername.Name := 'lbUsername';
    lbUsername.Left := 8;
    lbUsername.Top := 24;
    lbUsername.Width := 53;
    lbUsername.Height := 15;
    lbUsername.Caption := 'Username';
    lbUsername.HeightPercent := 100.000000000000000000;
    lbUsername.WidthPercent := 100.000000000000000000;
    lbUserID.SetParentComponent(shUsers);
    lbUserID.Name := 'lbUserID';
    lbUserID.Left := 8;
    lbUserID.Top := 3;
    lbUserID.Width := 34;
    lbUserID.Height := 15;
    lbUserID.Caption := 'UserID';
    lbUserID.HeightPercent := 100.000000000000000000;
    lbUserID.WidthPercent := 100.000000000000000000;
    memo.SetParentComponent(shUsers);
    memo.Name := 'memo';
    memo.Left := 3;
    memo.Top := 142;
    memo.Width := 320;
    memo.Height := 186;
    memo.HeightPercent := 100.000000000000000000;
    memo.SelLength := 0;
    memo.SelStart := 0;
    memo.WidthPercent := 100.000000000000000000;
    btNextRace.SetParentComponent(shUsers);
    btNextRace.Name := 'btNextRace';
    btNextRace.Left := 136;
    btNextRace.Top := 91;
    btNextRace.Width := 96;
    btNextRace.Height := 25;
    btNextRace.Caption := 'NextRace';
    btNextRace.ChildOrder := 5;
    btNextRace.HeightPercent := 100.000000000000000000;
    btNextRace.WidthPercent := 100.000000000000000000;
    SetEvent(btNextRace, Self, 'OnClick', 'btNextRaceClick');
    btUsers.SetParentComponent(shUsers);
    btUsers.Name := 'btUsers';
    btUsers.Left := 8;
    btUsers.Top := 91;
    btUsers.Width := 96;
    btUsers.Height := 25;
    btUsers.Caption := 'Users';
    btUsers.ChildOrder := 5;
    btUsers.HeightPercent := 100.000000000000000000;
    btUsers.WidthPercent := 100.000000000000000000;
    SetEvent(btUsers, Self, 'OnClick', 'btUsersClick');
  finally
    pcAdmin.AfterLoadDFMValues;
    shRaceResult.AfterLoadDFMValues;
    lbGrandPrix.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    cbGrandPrix.AfterLoadDFMValues;
    gdRaceResult.AfterLoadDFMValues;
    gdRaceResDriver.AfterLoadDFMValues;
    btSaveRaceResult.AfterLoadDFMValues;
    rbSprint.AfterLoadDFMValues;
    rbRace.AfterLoadDFMValues;
    btGenBetResult.AfterLoadDFMValues;
    edBetResultYear.AfterLoadDFMValues;
    btBetResultYear.AfterLoadDFMValues;
    shQualiResult.AfterLoadDFMValues;
    lbQualiGrandPrix.AfterLoadDFMValues;
    lbQualiErgebnis.AfterLoadDFMValues;
    cbQualiGrandPrix.AfterLoadDFMValues;
    rbQualiRace.AfterLoadDFMValues;
    rbQualiSprint.AfterLoadDFMValues;
    gdQualiResult.AfterLoadDFMValues;
    gdQualiResDriver.AfterLoadDFMValues;
    btSaveQualiResult.AfterLoadDFMValues;
    shUsers.AfterLoadDFMValues;
    lbRefreshToken.AfterLoadDFMValues;
    lbAccessToken.AfterLoadDFMValues;
    lbUsername.AfterLoadDFMValues;
    lbUserID.AfterLoadDFMValues;
    memo.AfterLoadDFMValues;
    btNextRace.AfterLoadDFMValues;
    btUsers.AfterLoadDFMValues;
  end;
end;

end.